import { FormEvent, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { CategorySearch as CategorySearchProps } from './types';

type Props = {
  search: CategorySearchProps;
  onSubmit: (query: string) => void;
};

/**
 * Search within this category.
 *
 * Only the sections that allow it get one — `sectionpages.searchAllowed`, which today
 * means the adult ones, where browsing by title is the point and the catalogue is too
 * large to page through. Kept because the legacy page had it, not because it is new.
 */
export default function CategorySearch({ search, onSubmit }: Props) {
  const [query, setQuery] = useState(search.query);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    onSubmit(query.trim());
  };

  return (
    <form onSubmit={submit} className="mb-6">
      <div className="flex items-center gap-2 rounded-xl border border-solid border-slate-200 bg-white px-3 py-2">
        <label htmlFor="category-search" className="text-slate-400">
          <FontAwesomeIcon icon={faMagnifyingGlass} aria-hidden />
          <span className="sr-only">{search.placeholder}</span>
        </label>

        <input
          id="category-search"
          type="search"
          name="xSearch"
          value={query}
          placeholder={search.placeholder}
          onChange={(event) => setQuery(event.target.value)}
          className="w-full border-0 bg-transparent p-0 text-sm text-slate-900 focus:outline-none"
        />

        {search.query !== '' && (
          <button
            type="button"
            onClick={() => {
              setQuery('');
              onSubmit('');
            }}
            className="cursor-pointer border-0 bg-transparent p-0 text-sm text-slate-500"
          >
            <FontAwesomeIcon icon={faXmark} aria-hidden />
            <span className="sr-only">Clear search</span>
          </button>
        )}
      </div>
    </form>
  );
}
